class EuroCaseClients extends HTMLElement {
  connectedCallback() {
    this.swiperEl = this.querySelector('[data-case-clients-swiper]');
    this.mq = window.matchMedia('(min-width: 1200px)');
    this.onChange = () => this.sync();
    this.mq.addEventListener('change', this.onChange);
    this.whenReady(() => this.sync());
  }

  disconnectedCallback() {
    this.mq?.removeEventListener('change', this.onChange);
    clearInterval(this.readyTimer);
    this.destroy();
  }

  whenReady(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    this.readyTimer = setInterval(() => {
      if (!window.Swiper) return;
      clearInterval(this.readyTimer);
      callback();
    }, 30);
  }

  spaceBetween() {
    if (this.mq.matches) return (20 / 1920) * window.innerWidth;
    return (12 / 375) * window.innerWidth;
  }

  sync() {
    this.destroy();
    this.init();
  }

  init() {
    if (!this.swiperEl || !window.Swiper) return;

    const slides = this.swiperEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    this.swiper = new window.Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: this.spaceBetween(),
      speed: 450,
      watchOverflow: true,
      grabCursor: true,
    });

    window.EuroAOS?.refresh();
  }

  destroy() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

customElements.define('euro-case-clients', EuroCaseClients);
